export const surveys = [
  {
    "name": "Alice Johnson",
    "age": 29,
    "gender": "Female",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Nurse"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "Hospitals"
    },
    "skill": {
      "skill_group": "Healthcare",
      "skill": "Patient Care"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Mental Health Awareness"
    },
    "population": {
      "population_group": "Youth",
      "population": "Young Adults"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4,
      "rating": {
        "2.1": 4,
        "2.2": 3,
        "2.3": 5,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.75,
      "rating": {
        "3.1": 4,
        "3.2": 3,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.4,
      "average_interest": 3.6,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 4
        },
        "4.2": {
          "history": 2,
          "interest": 3
        },
        "4.3": {
          "history": 4,
          "interest": 5
        },
        "4.4": {
          "history": 1,
          "interest": 2
        },
        "4.5": {
          "history": 3,
          "interest": 4
        },
        "4.6": {
          "history": 6,
          "interest": 3
        },
        "4.7": {
          "history": 3,
          "interest": 4
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Single parents"
  },
  {
    "name": "David Smith",
    "age": 45,
    "gender": "Male",
    "status": "Retired",
    "occupation": {
      "occupational_group": "Retired",
      "occupation": "Retired"
    },
    "industry": {
      "industry_group": "Retired",
      "industry": "Retired"
    },
    "skill": {
      "skill_group": "Retired",
      "skill": "Retired"
    },
    "cause": {
      "cause_group": "Retired",
      "cause": "Retired"
    },
    "population": {
      "population_group": "Seniors",
      "population": "Senior Adults"
    },
    "community": "My Family",
    "sentiments": {
      "average": 3.2,
      "rating": {
        "2.1": 3,
        "2.2": 2,
        "2.3": 4,
        "2.4": 3,
        "2.5": 3
      }
    },
    "practices": {
      "average": 2.75,
      "rating": {
        "3.1": 2,
        "3.2": 3,
        "3.3": 2.5,
        "3.4": 3
      }
    },
    "church_engagements": {
      "average_history": 6.1,
      "average_interest": 2.7,
      "rating": {
        "4.1": {
          "history": 10,
          "interest": 2
        },
        "4.2": {
          "history": 5,
          "interest": 3
        },
        "4.3": {
          "history": 8,
          "interest": 4
        },
        "4.4": {
          "history": 3,
          "interest": 1
        },
        "4.5": {
          "history": 4,
          "interest": 3
        },
        "4.6": {
          "history": 6,
          "interest": 2
        },
        "4.7": {
          "history": 7,
          "interest": 4
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Families"
  },
  {
    "name": "Emma Brown",
    "age": 34,
    "gender": "Female",
    "status": "Student",
    "occupation": {
      "occupational_group": "Student",
      "occupation": "Student"
    },
    "industry": {
      "industry_group": "Education",
      "industry": "University"
    },
    "skill": {
      "skill_group": "Learning",
      "skill": "Research"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Higher Education"
    },
    "population": {
      "population_group": "Youth",
      "population": "College Students"
    },
    "community": "My City",
    "sentiments": {
      "average": 4.2,
      "rating": {
        "2.1": 4,
        "2.2": 5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.9,
      "average_interest": 3.7,
      "rating": {
        "4.1": {
          "history": 2,
          "interest": 5
        },
        "4.2": {
          "history": 1,
          "interest": 3
        },
        "4.3": {
          "history": 0,
          "interest": 4
        },
        "4.4": {
          "history": 3,
          "interest": 2
        },
        "4.5": {
          "history": 2,
          "interest": 5
        },
        "4.6": {
          "history": 4,
          "interest": 3
        },
        "4.7": {
          "history": 1,
          "interest": 4
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Families"
  },
  {
    "name": "Michael Davis",
    "age": 51,
    "gender": "Male",
    "status": "Caregiver",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Home Health Aide"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "Home Healthcare"
    },
    "skill": {
      "skill_group": "Healthcare",
      "skill": "Elder Care"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Elderly Support"
    },
    "population": {
      "population_group": "Seniors",
      "population": "Elderly"
    },
    "community": "My City",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 4,
        "2.2": 3,
        "2.3": 4,
        "2.4": 3,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.25,
      "rating": {
        "3.1": 3,
        "3.2": 3,
        "3.3": 4,
        "3.4": 3
      }
    },
    "church_engagements": {
      "average_history": 5,
      "average_interest": 3.7,
      "rating": {
        "4.1": {
          "history": 8,
          "interest": 5
        },
        "4.2": {
          "history": 4,
          "interest": 3
        },
        "4.3": {
          "history": 6,
          "interest": 4
        },
        "4.4": {
          "history": 2,
          "interest": 2
        },
        "4.5": {
          "history": 5,
          "interest": 3
        },
        "4.6": {
          "history": 3,
          "interest": 4
        },
        "4.7": {
          "history": 7,
          "interest": 5
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Parents"
  },
  {
    "name": "Sophia Martinez",
    "age": 42,
    "gender": "Female",
    "status": "Volunteer",
    "occupation": {
      "occupational_group": "Community and Social Services",
      "occupation": "Social Worker"
    },
    "industry": {
      "industry_group": "Community and Social Services",
      "industry": "Nonprofit"
    },
    "skill": {
      "skill_group": "Social Services",
      "skill": "Counseling"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Youth Mentoring"
    },
    "population": {
      "population_group": "Youth",
      "population": "Adolescents"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4.4,
      "rating": {
        "2.1": 5,
        "2.2": 4,
        "2.3": 4,
        "2.4": 5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4.25,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.6,
      "average_interest": 4.4,
      "rating": {
        "4.1": {
          "history": 3,
          "interest": 5
        },
        "4.2": {
          "history": 6,
          "interest": 4
        },
        "4.3": {
          "history": 5,
          "interest": 5
        },
        "4.4": {
          "history": 2,
          "interest": 3
        },
        "4.5": {
          "history": 3,
          "interest": 5
        },
        "4.6": {
          "history": 4,
          "interest": 4
        },
        "4.7": {
          "history": 2,
          "interest": 5
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Singles"
  },
  {
    "name": "James Wilson",
    "age": 37,
    "gender": "Male",
    "status": "Homemaker",
    "occupation": {
      "occupational_group": "Homemaker",
      "occupation": "Homemaker"
    },
    "industry": {
      "industry_group": "Homemaker",
      "industry": "Homemaker"
    },
    "skill": {
      "skill_group": "Homemaking",
      "skill": "Childcare"
    },
    "cause": {
      "cause_group": "Family Support",
      "cause": "Parenting Support"
    },
    "population": {
      "population_group": "Families",
      "population": "Parents"
    },
    "community": "My Family",
    "sentiments": {
      "average": 3.5,
      "rating": {
        "2.1": 3,
        "2.2": 4,
        "2.3": 3,
        "2.4": 4,
        "2.5": 3
      }
    },
    "practices": {
      "average": 3,
      "rating": {
        "3.1": 3,
        "3.2": 3,
        "3.3": 3,
        "3.4": 3
      }
    },
    "church_engagements": {
      "average_history": 2.7,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 4,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 2
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 1,
          "interest": 2
        },
        "4.5": {
          "history": 2,
          "interest": 3
        },
        "4.6": {
          "history": 3,
          "interest": 2
        },
        "4.7": {
          "history": 4,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Parents"
  },
  {
    "name": "Olivia Taylor",
    "age": 30,
    "gender": "Female",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Business and Financial Operations",
      "occupation": "Financial Analyst"
    },
    "industry": {
      "industry_group": "Finance and Insurance",
      "industry": "Investment Banking"
    },
    "skill": {
      "skill_group": "Finance",
      "skill": "Financial Modeling"
    },
    "cause": {
      "cause_group": "Economic Development",
      "cause": "Financial Literacy"
    },
    "population": {
      "population_group": "Adults",
      "population": "Working Professionals"
    },
    "community": "My City",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4,
        "2.4": 5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.75,
      "rating": {
        "3.1": 4,
        "3.2": 3,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 4,
      "average_interest": 2.9,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 2
        },
        "4.3": {
          "history": 6,
          "interest": 4
        },
        "4.4": {
          "history": 3,
          "interest": 2
        },
        "4.5": {
          "history": 4,
          "interest": 3
        },
        "4.6": {
          "history": 3,
          "interest": 2
        },
        "4.7": {
          "history": 5,
          "interest": 4
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Single parents"
  },
  {
    "name": "Lucas White",
    "age": 28,
    "gender": "Male",
    "status": "Student",
    "occupation": {
      "occupational_group": "Student",
      "occupation": "Student"
    },
    "industry": {
      "industry_group": "Education",
      "industry": "University"
    },
    "skill": {
      "skill_group": "Learning",
      "skill": "Critical Thinking"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "STEM Education"
    },
    "population": {
      "population_group": "Youth",
      "population": "University Students"
    },
    "community": "My University",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 4,
        "2.2": 3,
        "2.3": 4,
        "2.4": 4,
        "2.5": 3
      }
    },
    "practices": {
      "average": 3.5,
      "rating": {
        "3.1": 4,
        "3.2": 3,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.3,
      "average_interest": 3,
      "rating": {
        "4.1": {
          "history": 2,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 2
        },
        "4.3": {
          "history": 0,
          "interest": 3
        },
        "4.4": {
          "history": 2,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 3
        },
        "4.7": {
          "history": 1,
          "interest": 4
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Married couples"
  },
  {
    "name": "Ella Anderson",
    "age": 40,
    "gender": "Female",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Legal",
      "occupation": "Lawyer"
    },
    "industry": {
      "industry_group": "Legal Services",
      "industry": "Law Firm"
    },
    "skill": {
      "skill_group": "Legal",
      "skill": "Litigation"
    },
    "cause": {
      "cause_group": "Social Justice",
      "cause": "Legal Aid"
    },
    "population": {
      "population_group": "Adults",
      "population": "Legal Professionals"
    },
    "community": "My City",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 4,
        "2.2": 3,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 4,
      "average_interest": 3.3,
      "rating": {
        "4.1": {
          "history": 7,
          "interest": 3
        },
        "4.2": {
          "history": 3,
          "interest": 2
        },
        "4.3": {
          "history": 5,
          "interest": 4
        },
        "4.4": {
          "history": 4,
          "interest": 3
        },
        "4.5": {
          "history": 3,
          "interest": 4
        },
        "4.6": {
          "history": 2,
          "interest": 3
        },
        "4.7": {
          "history": 4,
          "interest": 4
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Singles"
  },
  {
    "name": "Benjamin Lee",
    "age": 36,
    "gender": "Male",
    "status": "Volunteer",
    "occupation": {
      "occupational_group": "Community and Social Services",
      "occupation": "Community Organizer"
    },
    "industry": {
      "industry_group": "Nonprofit",
      "industry": "Community Services"
    },
    "skill": {
      "skill_group": "Community Engagement",
      "skill": "Event Planning"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Local Support Initiatives"
    },
    "population": {
      "population_group": "Adults",
      "population": "Community Leaders"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4.3,
      "rating": {
        "2.1": 4,
        "2.2": 5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.9,
      "average_interest": 4.1,
      "rating": {
        "4.1": {
          "history": 6,
          "interest": 4
        },
        "4.2": {
          "history": 3,
          "interest": 3
        },
        "4.3": {
          "history": 5,
          "interest": 5
        },
        "4.4": {
          "history": 2,
          "interest": 4
        },
        "4.5": {
          "history": 4,
          "interest": 4
        },
        "4.6": {
          "history": 3,
          "interest": 4
        },
        "4.7": {
          "history": 4,
          "interest": 5
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Widows"
  },
  {
    "name": "Charlotte Robinson",
    "age": 26,
    "gender": "Female",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Arts, Design, Entertainment, Sports, and Media",
      "occupation": "Graphic Designer"
    },
    "industry": {
      "industry_group": "Design Services",
      "industry": "Graphic Design"
    },
    "skill": {
      "skill_group": "Creative",
      "skill": "Illustration"
    },
    "cause": {
      "cause_group": "Arts and Culture",
      "cause": "Creative Education"
    },
    "population": {
      "population_group": "Young Adults",
      "population": "Artists"
    },
    "community": "My City",
    "sentiments": {
      "average": 4,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4.2,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3,
      "average_interest": 3.1,
      "rating": {
        "4.1": {
          "history": 4,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 2
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 5,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 4,
          "interest": 3
        },
        "4.7": {
          "history": 2,
          "interest": 5
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Married couples"
  },
  {
    "name": "James Clark",
    "age": 45,
    "gender": "Male",
    "status": "Retired",
    "occupation": {
      "occupational_group": "Management",
      "occupation": "Project Manager"
    },
    "industry": {
      "industry_group": "Construction",
      "industry": "Residential Construction"
    },
    "skill": {
      "skill_group": "Management",
      "skill": "Project Planning"
    },
    "cause": {
      "cause_group": "Community Support",
      "cause": "Elder Care"
    },
    "population": {
      "population_group": "Seniors",
      "population": "Retirees"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 3.7,
      "rating": {
        "2.1": 3,
        "2.2": 4,
        "2.3": 4,
        "2.4": 4,
        "2.5": 3
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 5,
      "average_interest": 3.7,
      "rating": {
        "4.1": {
          "history": 8,
          "interest": 5
        },
        "4.2": {
          "history": 4,
          "interest": 3
        },
        "4.3": {
          "history": 6,
          "interest": 4
        },
        "4.4": {
          "history": 7,
          "interest": 5
        },
        "4.5": {
          "history": 5,
          "interest": 4
        },
        "4.6": {
          "history": 2,
          "interest": 2
        },
        "4.7": {
          "history": 3,
          "interest": 3
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Families"
  },
  {
    "name": "Emma Davis",
    "age": 34,
    "gender": "Female",
    "status": "SAHP",
    "occupation": {
      "occupational_group": "Arts, Design, Entertainment, Sports, and Media",
      "occupation": "Graphic Designer"
    },
    "industry": {
      "industry_group": "Professional, Scientific, and Technical Services",
      "industry": "Design Services"
    },
    "skill": {
      "skill_group": "Creative Arts",
      "skill": "Graphic Design"
    },
    "cause": {
      "cause_group": "Arts and Culture",
      "cause": "Public Art Installations"
    },
    "population": {
      "population_group": "Urban Communities",
      "population": "Urban Families"
    },
    "community": "My Social Club",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 4,
        "2.2": 3,
        "2.3": 4,
        "2.4": 4,
        "2.5": 3
      }
    },
    "practices": {
      "average": 3.7,
      "rating": {
        "3.1": 3.5,
        "3.2": 4,
        "3.3": 4,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 1.9,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 2,
          "interest": 3
        },
        "4.2": {
          "history": 1,
          "interest": 2
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 2,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 4,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Married couples"
  },
  {
    "name": "Oliver Wilson",
    "age": 27,
    "gender": "Male",
    "status": "Student",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "College Student"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "Colleges and Universities"
    },
    "skill": {
      "skill_group": "Information Technology",
      "skill": "Programming"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "STEM Education"
    },
    "population": {
      "population_group": "Youth",
      "population": "College Students"
    },
    "community": "My School",
    "sentiments": {
      "average": 4.2,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 5,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.1,
      "average_interest": 2.1,
      "rating": {
        "4.1": {
          "history": 3,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 2
        },
        "4.3": {
          "history": 2,
          "interest": 3
        },
        "4.4": {
          "history": 1,
          "interest": 2
        },
        "4.5": {
          "history": 0,
          "interest": 1
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 2
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Singles"
  },
  {
    "name": "Sophia Martinez",
    "age": 39,
    "gender": "Female",
    "status": "Volunteer",
    "occupation": {
      "occupational_group": "Social Services",
      "occupation": "Volunteer Coordinator"
    },
    "industry": {
      "industry_group": "Community Development",
      "industry": "Community Centers"
    },
    "skill": {
      "skill_group": "Leadership",
      "skill": "Team Management"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Local Business Support"
    },
    "population": {
      "population_group": "Low-Income",
      "population": "Single Parents"
    },
    "community": "My Volunteer Group",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4,
        "2.4": 4,
        "2.5": 5
      }
    },
    "practices": {
      "average": 4.3,
      "rating": {
        "3.1": 4,
        "3.2": 5,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.3,
      "average_interest": 3.7,
      "rating": {
        "4.1": {
          "history": 6,
          "interest": 5
        },
        "4.2": {
          "history": 3,
          "interest": 4
        },
        "4.3": {
          "history": 5,
          "interest": 5
        },
        "4.4": {
          "history": 2,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 3
        },
        "4.7": {
          "history": 4,
          "interest": 4
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Married couples"
  },
  {
    "name": "James Anderson",
    "age": 45,
    "gender": "Male",
    "status": "Retired",
    "occupation": {
      "occupational_group": "Management",
      "occupation": "Retired Executive"
    },
    "industry": {
      "industry_group": "Finance and Insurance",
      "industry": "Investment Banking"
    },
    "skill": {
      "skill_group": "Leadership",
      "skill": "Strategic Planning"
    },
    "cause": {
      "cause_group": "Financial Literacy",
      "cause": "Investment Education"
    },
    "population": {
      "population_group": "Seniors",
      "population": "Retirees"
    },
    "community": "My Golf Club",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 4,
        "2.2": 3,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 4.4,
      "average_interest": 3.1,
      "rating": {
        "4.1": {
          "history": 10,
          "interest": 5
        },
        "4.2": {
          "history": 4,
          "interest": 3
        },
        "4.3": {
          "history": 6,
          "interest": 4
        },
        "4.4": {
          "history": 2,
          "interest": 2
        },
        "4.5": {
          "history": 1,
          "interest": 1
        },
        "4.6": {
          "history": 3,
          "interest": 3
        },
        "4.7": {
          "history": 5,
          "interest": 4
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Parents"
  },
  {
    "name": "Ava Brown",
    "age": 31,
    "gender": "Female",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Nurse"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "General Medical and Surgical Hospitals"
    },
    "skill": {
      "skill_group": "Medical",
      "skill": "Patient Care"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Mental Health Support"
    },
    "population": {
      "population_group": "General Public",
      "population": "Working Adults"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4.2,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 2.6,
      "average_interest": 3,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 5
        },
        "4.2": {
          "history": 2,
          "interest": 2
        },
        "4.3": {
          "history": 4,
          "interest": 3
        },
        "4.4": {
          "history": 3,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 2
        },
        "4.7": {
          "history": 2,
          "interest": 3
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Single parents"
  },
  {
    "name": "Mia Johnson",
    "age": 29,
    "gender": "Female",
    "status": "Homemaker",
    "occupation": {
      "occupational_group": "Community and Social Service",
      "occupation": "Family Support Specialist"
    },
    "industry": {
      "industry_group": "Social Assistance",
      "industry": "Family Services"
    },
    "skill": {
      "skill_group": "Support Services",
      "skill": "Counseling"
    },
    "cause": {
      "cause_group": "Family Support",
      "cause": "Childcare Services"
    },
    "population": {
      "population_group": "Families",
      "population": "Single Parents"
    },
    "community": "My Local Parenting Group",
    "sentiments": {
      "average": 3.7,
      "rating": {
        "2.1": 3,
        "2.2": 4,
        "2.3": 4,
        "2.4": 4,
        "2.5": 3
      }
    },
    "practices": {
      "average": 3.6,
      "rating": {
        "3.1": 3,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.4,
      "average_interest": 2.4,
      "rating": {
        "4.1": {
          "history": 3,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 2
        },
        "4.3": {
          "history": 2,
          "interest": 3
        },
        "4.4": {
          "history": 1,
          "interest": 2
        },
        "4.5": {
          "history": 0,
          "interest": 1
        },
        "4.6": {
          "history": 1,
          "interest": 2
        },
        "4.7": {
          "history": 2,
          "interest": 3
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Parents"
  },
  {
    "name": "Emily Johnson",
    "age": 29,
    "gender": "Female",
    "status": "Student",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "Elementary School Teacher"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "Elementary and Secondary Schools"
    },
    "skill": {
      "skill_group": "Communication",
      "skill": "Active Listening"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Adult Literacy Programs"
    },
    "population": {
      "population_group": "Youth",
      "population": "College Students"
    },
    "community": "My School",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 4,
        "2.2": 3.5,
        "2.3": 4.5,
        "2.4": 3,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.7,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 3,
        "3.4": 4.5
      }
    },
    "church_engagements": {
      "average_history": 1,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 2,
          "interest": 3
        },
        "4.2": {
          "history": 0,
          "interest": 2.5
        },
        "4.3": {
          "history": 1,
          "interest": 3
        },
        "4.4": {
          "history": 3,
          "interest": 4
        },
        "4.5": {
          "history": 0,
          "interest": 1
        },
        "4.6": {
          "history": 1,
          "interest": 2
        },
        "4.7": {
          "history": 0,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Widows"
  },
  {
    "name": "Michael Lee",
    "age": 40,
    "gender": "Male",
    "status": "Retired",
    "occupation": {
      "occupational_group": "Management",
      "occupation": "Marketing Manager"
    },
    "industry": {
      "industry_group": "Retail Trade",
      "industry": "Clothing Stores"
    },
    "skill": {
      "skill_group": "Sales and Marketing",
      "skill": "Sales Strategy"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Affordable Housing"
    },
    "population": {
      "population_group": "Seniors",
      "population": "Retirees"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4.2,
      "rating": {
        "2.1": 4.5,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 6.1,
      "average_interest": 3.7,
      "rating": {
        "4.1": {
          "history": 10,
          "interest": 5
        },
        "4.2": {
          "history": 5,
          "interest": 4
        },
        "4.3": {
          "history": 7,
          "interest": 3
        },
        "4.4": {
          "history": 8,
          "interest": 4
        },
        "4.5": {
          "history": 6,
          "interest": 3
        },
        "4.6": {
          "history": 3,
          "interest": 2
        },
        "4.7": {
          "history": 4,
          "interest": 5
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Families"
  },
  {
    "name": "Sophia Brown",
    "age": 34,
    "gender": "Female",
    "status": "Homemaker",
    "occupation": {
      "occupational_group": "Arts, Design, Entertainment, Sports, and Media",
      "occupation": "Photographer"
    },
    "industry": {
      "industry_group": "Arts and Culture",
      "industry": "Public Art Installations"
    },
    "skill": {
      "skill_group": "Creative Arts",
      "skill": "Photography"
    },
    "cause": {
      "cause_group": "Arts and Culture",
      "cause": "Arts Education"
    },
    "population": {
      "population_group": "Urban Communities",
      "population": "Urban Families"
    },
    "community": "My Social Club",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 4,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 4.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 3.5,
        "3.2": 4,
        "3.3": 4,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 1.6,
      "average_interest": 2.7,
      "rating": {
        "4.1": {
          "history": 4,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 4
        },
        "4.3": {
          "history": 3,
          "interest": 2
        },
        "4.4": {
          "history": 1,
          "interest": 3
        },
        "4.5": {
          "history": 0,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 4
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Single parents"
  },
  {
    "name": "Daniel Garcia",
    "age": 31,
    "gender": "Male",
    "status": "Volunteer",
    "occupation": {
      "occupational_group": "Community and Social Service",
      "occupation": "Social Worker"
    },
    "industry": {
      "industry_group": "Social Assistance",
      "industry": "Social Services"
    },
    "skill": {
      "skill_group": "Interpersonal",
      "skill": "Counseling"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Homeless Assistance"
    },
    "population": {
      "population_group": "Homeless Individuals",
      "population": "Street Youth"
    },
    "community": "My Volunteer Organization",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4,
        "2.2": 3.5,
        "2.3": 4.5,
        "2.4": 4,
        "2.5": 4.5
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4.5,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 2.7,
      "average_interest": 3.1,
      "rating": {
        "4.1": {
          "history": 8,
          "interest": 5
        },
        "4.2": {
          "history": 2,
          "interest": 4
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 4,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 3
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Parents"
  },
  {
    "name": "Olivia Martinez",
    "age": 26,
    "gender": "Female",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Business and Financial Operations",
      "occupation": "Financial Analyst"
    },
    "industry": {
      "industry_group": "Finance and Insurance",
      "industry": "Investment Banking"
    },
    "skill": {
      "skill_group": "Analytical",
      "skill": "Financial Analysis"
    },
    "cause": {
      "cause_group": "Economic Development",
      "cause": "Financial Literacy"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Early Career"
    },
    "community": "My Professional Network",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 3.5,
        "2.2": 4,
        "2.3": 4,
        "2.4": 3,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 3,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 2.1,
      "average_interest": 3.1,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 3
        },
        "4.3": {
          "history": 2,
          "interest": 2
        },
        "4.4": {
          "history": 4,
          "interest": 4
        },
        "4.5": {
          "history": 0,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 3
        },
        "4.7": {
          "history": 2,
          "interest": 4
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Singles"
  },
  {
    "name": "Liam Wilson",
    "age": 45,
    "gender": "Male",
    "status": "Retired",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Physical Therapist"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "Physical Therapy Services"
    },
    "skill": {
      "skill_group": "Healthcare",
      "skill": "Physical Therapy"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Chronic Disease Management"
    },
    "population": {
      "population_group": "Seniors",
      "population": "Retired Individuals"
    },
    "community": "My Retirement Community",
    "sentiments": {
      "average": 4.3,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4,
        "2.4": 5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4.2,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 7,
      "average_interest": 3.7,
      "rating": {
        "4.1": {
          "history": 15,
          "interest": 5
        },
        "4.2": {
          "history": 6,
          "interest": 4
        },
        "4.3": {
          "history": 8,
          "interest": 3
        },
        "4.4": {
          "history": 10,
          "interest": 5
        },
        "4.5": {
          "history": 3,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 3
        },
        "4.7": {
          "history": 5,
          "interest": 4
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Families"
  },
  {
    "name": "Sophia Robinson",
    "age": 29,
    "gender": "Female",
    "status": "Student",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "Graduate Student"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "University Education"
    },
    "skill": {
      "skill_group": "Academic",
      "skill": "Research"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Higher Education Access"
    },
    "population": {
      "population_group": "Students",
      "population": "Graduate Students"
    },
    "community": "My University",
    "sentiments": {
      "average": 4.2,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4,
        "2.4": 4.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4.5,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.9,
      "average_interest": 2.9,
      "rating": {
        "4.1": {
          "history": 4,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 4
        },
        "4.3": {
          "history": 1,
          "interest": 3
        },
        "4.4": {
          "history": 3,
          "interest": 4
        },
        "4.5": {
          "history": 0,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 1
        },
        "4.7": {
          "history": 2,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Parents"
  },
  {
    "name": "Ethan Thompson",
    "age": 38,
    "gender": "Male",
    "status": "Homemaker",
    "occupation": {
      "occupational_group": "Management",
      "occupation": "Household Manager"
    },
    "industry": {
      "industry_group": "Non-Profit",
      "industry": "Household Management"
    },
    "skill": {
      "skill_group": "Organizational",
      "skill": "Household Budgeting"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Family Support"
    },
    "population": {
      "population_group": "SAHP Parents",
      "population": "Homemakers"
    },
    "community": "My Family",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 3.5,
        "2.2": 4,
        "2.3": 3.5,
        "2.4": 4,
        "2.5": 3.5
      }
    },
    "practices": {
      "average": 3.7,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 3,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 3.3,
      "average_interest": 3,
      "rating": {
        "4.1": {
          "history": 6,
          "interest": 4
        },
        "4.2": {
          "history": 3,
          "interest": 3
        },
        "4.3": {
          "history": 2,
          "interest": 2
        },
        "4.4": {
          "history": 5,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 3
        },
        "4.7": {
          "history": 4,
          "interest": 4
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Singles"
  },
  {
    "name": "Ava Johnson",
    "age": 42,
    "gender": "Female",
    "status": "Caregiver",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Home Health Aide"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "Home Health Care Services"
    },
    "skill": {
      "skill_group": "Healthcare",
      "skill": "Patient Care"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Elderly Care"
    },
    "population": {
      "population_group": "Elderly",
      "population": "Senior Care"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4.4,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4.5,
        "2.4": 5,
        "2.5": 4.5
      }
    },
    "practices": {
      "average": 4.2,
      "rating": {
        "3.1": 4,
        "3.2": 4.5,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 5.6,
      "average_interest": 3.6,
      "rating": {
        "4.1": {
          "history": 12,
          "interest": 5
        },
        "4.2": {
          "history": 5,
          "interest": 4
        },
        "4.3": {
          "history": 7,
          "interest": 3
        },
        "4.4": {
          "history": 8,
          "interest": 4
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 3
        },
        "4.7": {
          "history": 4,
          "interest": 4
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Singles"
  },
  {
    "name": "James Lee",
    "age": 50,
    "gender": "Male",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Architecture and Engineering",
      "occupation": "Civil Engineer"
    },
    "industry": {
      "industry_group": "Construction",
      "industry": "Civil Engineering"
    },
    "skill": {
      "skill_group": "Engineering",
      "skill": "Project Management"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Infrastructure Improvement"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Mid-Career Engineers"
    },
    "community": "My Workplace",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 4,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 4.4,
      "average_interest": 2.7,
      "rating": {
        "4.1": {
          "history": 8,
          "interest": 3
        },
        "4.2": {
          "history": 4,
          "interest": 3
        },
        "4.3": {
          "history": 5,
          "interest": 2
        },
        "4.4": {
          "history": 6,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 3,
          "interest": 2
        },
        "4.7": {
          "history": 4,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Families"
  },
  {
    "name": "Mia Brown",
    "age": 34,
    "gender": "Female",
    "status": "Unemployed",
    "occupation": {
      "occupational_group": "",
      "occupation": ""
    },
    "industry": {
      "industry_group": "",
      "industry": ""
    },
    "skill": {
      "skill_group": "",
      "skill": ""
    },
    "cause": {
      "cause_group": "Arts and Culture",
      "cause": "Arts Education"
    },
    "population": {
      "population_group": "Unemployed",
      "population": "Job Seekers"
    },
    "community": "My Social Club",
    "sentiments": {
      "average": 4,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4.5,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.9,
      "rating": {
        "3.1": 4,
        "3.2": 4.5,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3,
      "average_interest": 3,
      "rating": {
        "4.1": {
          "history": 7,
          "interest": 4
        },
        "4.2": {
          "history": 3,
          "interest": 3
        },
        "4.3": {
          "history": 2,
          "interest": 2
        },
        "4.4": {
          "history": 5,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 3
        },
        "4.6": {
          "history": 0,
          "interest": 2
        },
        "4.7": {
          "history": 3,
          "interest": 3
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Families"
  },
  {
    "name": "Noah White",
    "age": 40,
    "gender": "Male",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Sales and Related",
      "occupation": "Sales Representative"
    },
    "industry": {
      "industry_group": "Retail Trade",
      "industry": "Electronics Sales"
    },
    "skill": {
      "skill_group": "Sales and Marketing",
      "skill": "Customer Relationship Management"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Affordable Housing"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Sales Professionals"
    },
    "community": "My Workplace",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4.5,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4.5,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 4.9,
      "average_interest": 3.4,
      "rating": {
        "4.1": {
          "history": 9,
          "interest": 4
        },
        "4.2": {
          "history": 5,
          "interest": 4
        },
        "4.3": {
          "history": 6,
          "interest": 3
        },
        "4.4": {
          "history": 7,
          "interest": 4
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 3
        },
        "4.7": {
          "history": 3,
          "interest": 4
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Single parents"
  },
  {
    "name": "Emily Harris",
    "age": 28,
    "gender": "Female",
    "status": "Caregiver",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Personal Care Aide"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "Personal Care Services"
    },
    "skill": {
      "skill_group": "Healthcare",
      "skill": "Personal Care"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Disability Support"
    },
    "population": {
      "population_group": "Disabled",
      "population": "Physically Disabled"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4.3,
      "rating": {
        "2.1": 4.5,
        "2.2": 4,
        "2.3": 4,
        "2.4": 5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4.2,
      "rating": {
        "3.1": 4,
        "3.2": 4.5,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 2.4,
      "average_interest": 3.3,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 5
        },
        "4.2": {
          "history": 2,
          "interest": 4
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 4,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 2
        },
        "4.7": {
          "history": 2,
          "interest": 3
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Families"
  },
  {
    "name": "Lucas Martinez",
    "age": 46,
    "gender": "Male",
    "status": "Retired",
    "occupation": {
      "occupational_group": "Management",
      "occupation": "Operations Manager"
    },
    "industry": {
      "industry_group": "Manufacturing",
      "industry": "Industrial Operations"
    },
    "skill": {
      "skill_group": "Management",
      "skill": "Operations Management"
    },
    "cause": {
      "cause_group": "Economic Development",
      "cause": "Workforce Training"
    },
    "population": {
      "population_group": "Retirees",
      "population": "Retired Professionals"
    },
    "community": "My Old Company",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 4,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 3.5
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 5,
      "average_interest": 2.3,
      "rating": {
        "4.1": {
          "history": 10,
          "interest": 3
        },
        "4.2": {
          "history": 5,
          "interest": 3
        },
        "4.3": {
          "history": 6,
          "interest": 2
        },
        "4.4": {
          "history": 8,
          "interest": 3
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 1
        },
        "4.7": {
          "history": 3,
          "interest": 2
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Married couples"
  },
  {
    "name": "Olivia Wilson",
    "age": 31,
    "gender": "Female",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Business and Financial Operations",
      "occupation": "Financial Analyst"
    },
    "industry": {
      "industry_group": "Finance and Insurance",
      "industry": "Investment Banking"
    },
    "skill": {
      "skill_group": "Finance",
      "skill": "Financial Analysis"
    },
    "cause": {
      "cause_group": "Economic Development",
      "cause": "Financial Literacy"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Financial Analysts"
    },
    "community": "My Workplace",
    "sentiments": {
      "average": 4,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4.5,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.9,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.4,
      "average_interest": 2.9,
      "rating": {
        "4.1": {
          "history": 6,
          "interest": 3
        },
        "4.2": {
          "history": 4,
          "interest": 4
        },
        "4.3": {
          "history": 3,
          "interest": 2
        },
        "4.4": {
          "history": 5,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 2
        },
        "4.7": {
          "history": 3,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Single parents"
  },
  {
    "name": "Liam Adams",
    "age": 26,
    "gender": "Male",
    "status": "Student",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "Undergraduate Student"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "Higher Education"
    },
    "skill": {
      "skill_group": "Academic",
      "skill": "Critical Thinking"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Scholarships"
    },
    "population": {
      "population_group": "Students",
      "population": "Undergraduate Students"
    },
    "community": "My Campus",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4.5,
        "2.2": 4,
        "2.3": 4,
        "2.4": 4.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.3,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 3,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 3
        },
        "4.3": {
          "history": 2,
          "interest": 2
        },
        "4.4": {
          "history": 2,
          "interest": 3
        },
        "4.5": {
          "history": 0,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 3
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Families"
  },
  {
    "name": "Sophia Johnson",
    "age": 39,
    "gender": "Female",
    "status": "Caregiver",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Home Health Aide"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "Home Healthcare"
    },
    "skill": {
      "skill_group": "Healthcare",
      "skill": "Patient Care"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Substance Abuse Recovery"
    },
    "population": {
      "population_group": "Disabled",
      "population": "Physically Disabled"
    },
    "community": "My Local Support Group",
    "sentiments": {
      "average": 3.7,
      "rating": {
        "2.1": 3.5,
        "2.2": 3,
        "2.3": 4,
        "2.4": 4,
        "2.5": 3.5
      }
    },
    "practices": {
      "average": 3.6,
      "rating": {
        "3.1": 3.5,
        "3.2": 3.5,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.6,
      "average_interest": 2.3,
      "rating": {
        "4.1": {
          "history": 8,
          "interest": 3
        },
        "4.2": {
          "history": 3,
          "interest": 2
        },
        "4.3": {
          "history": 4,
          "interest": 3
        },
        "4.4": {
          "history": 5,
          "interest": 3
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 1
        },
        "4.7": {
          "history": 2,
          "interest": 2
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Singles"
  },
  {
    "name": "Mia Taylor",
    "age": 28,
    "gender": "Female",
    "status": "Volunteer",
    "occupation": {
      "occupational_group": "Arts, Design, Entertainment, Sports, and Media",
      "occupation": "Graphic Designer"
    },
    "industry": {
      "industry_group": "Professional, Scientific, and Technical Services",
      "industry": "Graphic Design Services"
    },
    "skill": {
      "skill_group": "Creative Arts",
      "skill": "Graphic Design"
    },
    "cause": {
      "cause_group": "Arts and Culture",
      "cause": "Public Art Installations"
    },
    "population": {
      "population_group": "Youth",
      "population": "Young Adults"
    },
    "community": "My Volunteer Group",
    "sentiments": {
      "average": 4.2,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4.5,
        "2.4": 5,
        "2.5": 4.5
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 2.3,
      "average_interest": 3.3,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 4
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 4,
          "interest": 4
        },
        "4.5": {
          "history": 2,
          "interest": 3
        },
        "4.6": {
          "history": 0,
          "interest": 2
        },
        "4.7": {
          "history": 1,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Married couples"
  },
  {
    "name": "Noah Brown",
    "age": 35,
    "gender": "Male",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Computer and Mathematical",
      "occupation": "Data Scientist"
    },
    "industry": {
      "industry_group": "Information Technology",
      "industry": "Data Processing and Hosting"
    },
    "skill": {
      "skill_group": "Information Technology",
      "skill": "Data Analysis"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "STEM Education"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Data Scientists"
    },
    "community": "My Workplace",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 4,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 3.5
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 3.4,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 6,
          "interest": 3
        },
        "4.2": {
          "history": 4,
          "interest": 3
        },
        "4.3": {
          "history": 3,
          "interest": 2
        },
        "4.4": {
          "history": 5,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 2
        },
        "4.7": {
          "history": 3,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Parents"
  },
  {
    "name": "Emma Wilson",
    "age": 50,
    "gender": "Female",
    "status": "SAHP",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "Home Educator"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "Home Schooling"
    },
    "skill": {
      "skill_group": "Education",
      "skill": "Curriculum Design"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Early Childhood Education"
    },
    "population": {
      "population_group": "Low-Income",
      "population": "Single Parents"
    },
    "community": "My Family",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 3.5,
        "2.2": 4,
        "2.3": 4,
        "2.4": 3.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.7,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 3.5,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 3.7,
      "average_interest": 2.3,
      "rating": {
        "4.1": {
          "history": 7,
          "interest": 3
        },
        "4.2": {
          "history": 3,
          "interest": 2
        },
        "4.3": {
          "history": 5,
          "interest": 3
        },
        "4.4": {
          "history": 6,
          "interest": 3
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 1
        },
        "4.7": {
          "history": 2,
          "interest": 2
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Single parents"
  },
  {
    "name": "Ethan Harris",
    "age": 40,
    "gender": "Male",
    "status": "Unemployed",
    "occupation": {
      "occupational_group": "",
      "occupation": ""
    },
    "industry": {
      "industry_group": "",
      "industry": ""
    },
    "skill": {
      "skill_group": "",
      "skill": ""
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Affordable Housing"
    },
    "population": {
      "population_group": "Low-Income",
      "population": "Working Poor"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 3.5,
      "rating": {
        "2.1": 3,
        "2.2": 3,
        "2.3": 3.5,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.4,
      "rating": {
        "3.1": 3,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 3
      }
    },
    "church_engagements": {
      "average_history": 2.3,
      "average_interest": 2.1,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 2
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 4,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 1
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 2
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Parents"
  },
  {
    "name": "Ava Scott",
    "age": 22,
    "gender": "Female",
    "status": "Student",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "Graduate Student"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "Higher Education"
    },
    "skill": {
      "skill_group": "Academic",
      "skill": "Research Skills"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Scholarships"
    },
    "population": {
      "population_group": "Students",
      "population": "Graduate Students"
    },
    "community": "My School",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4.5,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.1,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 2,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 3
        },
        "4.3": {
          "history": 2,
          "interest": 2
        },
        "4.4": {
          "history": 2,
          "interest": 3
        },
        "4.5": {
          "history": 0,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 3
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Single parents"
  },
  {
    "name": "James Robinson",
    "age": 27,
    "gender": "Male",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Sales and Related",
      "occupation": "Sales Representative"
    },
    "industry": {
      "industry_group": "Retail Trade",
      "industry": "Clothing Stores"
    },
    "skill": {
      "skill_group": "Sales and Marketing",
      "skill": "Sales Strategy"
    },
    "cause": {
      "cause_group": "Poverty Alleviation",
      "cause": "Job Training Programs"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Sales Representatives"
    },
    "community": "My Workplace",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 4,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 3.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.7,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 3.5,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 2.3,
      "average_interest": 2.3,
      "rating": {
        "4.1": {
          "history": 4,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 2
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 4,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 2,
          "interest": 2
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Married couples"
  },
  {
    "name": "Liam Miller",
    "age": 33,
    "gender": "Male",
    "status": "Volunteer",
    "occupation": {
      "occupational_group": "Community and Social Service",
      "occupation": "Community Outreach Coordinator"
    },
    "industry": {
      "industry_group": "Social Assistance",
      "industry": "Community Service"
    },
    "skill": {
      "skill_group": "Social Services",
      "skill": "Community Outreach"
    },
    "cause": {
      "cause_group": "Poverty Alleviation",
      "cause": "Homeless Shelters"
    },
    "population": {
      "population_group": "Low-Income",
      "population": "Homeless"
    },
    "community": "My Volunteer Group",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4,
        "2.4": 4.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.3,
      "average_interest": 2.9,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 4
        },
        "4.2": {
          "history": 3,
          "interest": 3
        },
        "4.3": {
          "history": 4,
          "interest": 3
        },
        "4.4": {
          "history": 5,
          "interest": 4
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 1
        },
        "4.7": {
          "history": 3,
          "interest": 3
        }
      }
    },
    "work_location": "Hybrid",
    "relationship_status": "Parents"
  },
  {
    "name": "Olivia Harris",
    "age": 30,
    "gender": "Female",
    "status": "Student",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "Undergraduate Student"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "Higher Education"
    },
    "skill": {
      "skill_group": "Academic",
      "skill": "Critical Thinking"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Scholarships for Minorities"
    },
    "population": {
      "population_group": "Students",
      "population": "Undergraduate Students"
    },
    "community": "My College",
    "sentiments": {
      "average": 4.2,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4.5,
        "2.4": 4.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4.1,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.4,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 3,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 3
        },
        "4.3": {
          "history": 2,
          "interest": 3
        },
        "4.4": {
          "history": 2,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 2
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Widows"
  },
  {
    "name": "Benjamin Walker",
    "age": 45,
    "gender": "Male",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Business and Financial Operations",
      "occupation": "Financial Analyst"
    },
    "industry": {
      "industry_group": "Finance and Insurance",
      "industry": "Investment Banking"
    },
    "skill": {
      "skill_group": "Finance",
      "skill": "Financial Analysis"
    },
    "cause": {
      "cause_group": "Economic Development",
      "cause": "Financial Literacy Programs"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Finance Professionals"
    },
    "community": "My Professional Network",
    "sentiments": {
      "average": 3.8,
      "rating": {
        "2.1": 3.5,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.7,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 3.5,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 3.4,
      "average_interest": 2.6,
      "rating": {
        "4.1": {
          "history": 6,
          "interest": 4
        },
        "4.2": {
          "history": 3,
          "interest": 2
        },
        "4.3": {
          "history": 5,
          "interest": 3
        },
        "4.4": {
          "history": 5,
          "interest": 3
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 1
        },
        "4.7": {
          "history": 2,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Single parents"
  },
  {
    "name": "Aiden Martinez",
    "age": 29,
    "gender": "Male",
    "status": "Retired",
    "occupation": {
      "occupational_group": "Management",
      "occupation": "Project Manager"
    },
    "industry": {
      "industry_group": "Construction",
      "industry": "Project Management"
    },
    "skill": {
      "skill_group": "Management",
      "skill": "Project Coordination"
    },
    "cause": {
      "cause_group": "Community Development",
      "cause": "Affordable Housing"
    },
    "population": {
      "population_group": "Retirees",
      "population": "Retired Professionals"
    },
    "community": "My Retirement Community",
    "sentiments": {
      "average": 3.9,
      "rating": {
        "2.1": 4,
        "2.2": 4,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.8,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.9,
      "average_interest": 2.4,
      "rating": {
        "4.1": {
          "history": 7,
          "interest": 3
        },
        "4.2": {
          "history": 4,
          "interest": 2
        },
        "4.3": {
          "history": 5,
          "interest": 3
        },
        "4.4": {
          "history": 6,
          "interest": 4
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 1
        },
        "4.7": {
          "history": 2,
          "interest": 2
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Married couples"
  },
  {
    "name": "Isabella King",
    "age": 25,
    "gender": "Female",
    "status": "Homemaker",
    "occupation": {
      "occupational_group": "Community and Social Service",
      "occupation": "Childcare Provider"
    },
    "industry": {
      "industry_group": "Healthcare and Social Assistance",
      "industry": "Childcare Services"
    },
    "skill": {
      "skill_group": "Childcare",
      "skill": "Early Childhood Education"
    },
    "cause": {
      "cause_group": "Child Welfare",
      "cause": "Support for Single Parents"
    },
    "population": {
      "population_group": "Families",
      "population": "Single Parents"
    },
    "community": "My Community",
    "sentiments": {
      "average": 3.6,
      "rating": {
        "2.1": 3.5,
        "2.2": 3,
        "2.3": 4,
        "2.4": 3.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.5,
      "rating": {
        "3.1": 3,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 2.6,
      "average_interest": 2.3,
      "rating": {
        "4.1": {
          "history": 4,
          "interest": 3
        },
        "4.2": {
          "history": 2,
          "interest": 2
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 4,
          "interest": 3
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 1
        },
        "4.7": {
          "history": 2,
          "interest": 2
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Parents"
  },
  {
    "name": "Ethan Davis",
    "age": 38,
    "gender": "Male",
    "status": "Caregiver",
    "occupation": {
      "occupational_group": "Healthcare Practitioners and Technical",
      "occupation": "Home Health Aide"
    },
    "industry": {
      "industry_group": "Healthcare",
      "industry": "Home Health Care Services"
    },
    "skill": {
      "skill_group": "Healthcare",
      "skill": "Patient Care"
    },
    "cause": {
      "cause_group": "Healthcare and Wellness",
      "cause": "Support for the Elderly"
    },
    "population": {
      "population_group": "Elderly",
      "population": "Senior Citizens"
    },
    "community": "My Local Community",
    "sentiments": {
      "average": 4.3,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4,
        "2.4": 4.5,
        "2.5": 5
      }
    },
    "practices": {
      "average": 4.2,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.3,
      "average_interest": 3,
      "rating": {
        "4.1": {
          "history": 6,
          "interest": 4
        },
        "4.2": {
          "history": 2,
          "interest": 3
        },
        "4.3": {
          "history": 4,
          "interest": 3
        },
        "4.4": {
          "history": 5,
          "interest": 4
        },
        "4.5": {
          "history": 2,
          "interest": 2
        },
        "4.6": {
          "history": 1,
          "interest": 2
        },
        "4.7": {
          "history": 3,
          "interest": 3
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Singles"
  },
  {
    "name": "Sophia Johnson",
    "age": 27,
    "gender": "Female",
    "status": "Student",
    "occupation": {
      "occupational_group": "Education, Training, and Library",
      "occupation": "Graduate Student"
    },
    "industry": {
      "industry_group": "Educational Services",
      "industry": "Higher Education"
    },
    "skill": {
      "skill_group": "Academic",
      "skill": "Research"
    },
    "cause": {
      "cause_group": "Education and Literacy",
      "cause": "Research Grants"
    },
    "population": {
      "population_group": "Students",
      "population": "Graduate Students"
    },
    "community": "My University",
    "sentiments": {
      "average": 4,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.9,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 3.5,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 1.4,
      "average_interest": 2.7,
      "rating": {
        "4.1": {
          "history": 2,
          "interest": 4
        },
        "4.2": {
          "history": 1,
          "interest": 3
        },
        "4.3": {
          "history": 3,
          "interest": 3
        },
        "4.4": {
          "history": 2,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 0,
          "interest": 1
        },
        "4.7": {
          "history": 1,
          "interest": 2
        }
      }
    },
    "work_location": "Remote",
    "relationship_status": "Widows"
  },
  {
    "name": "Jackson White",
    "age": 50,
    "gender": "Male",
    "status": "Employed",
    "occupation": {
      "occupational_group": "Management",
      "occupation": "Operations Manager"
    },
    "industry": {
      "industry_group": "Manufacturing",
      "industry": "Industrial Operations"
    },
    "skill": {
      "skill_group": "Management",
      "skill": "Operations Management"
    },
    "cause": {
      "cause_group": "Economic Development",
      "cause": "Job Training Programs"
    },
    "population": {
      "population_group": "Working Professionals",
      "population": "Manufacturing Workers"
    },
    "community": "My Industry Network",
    "sentiments": {
      "average": 3.7,
      "rating": {
        "2.1": 3.5,
        "2.2": 3.5,
        "2.3": 4,
        "2.4": 4,
        "2.5": 4
      }
    },
    "practices": {
      "average": 3.6,
      "rating": {
        "3.1": 4,
        "3.2": 3.5,
        "3.3": 3.5,
        "3.4": 3.5
      }
    },
    "church_engagements": {
      "average_history": 4.7,
      "average_interest": 2.4,
      "rating": {
        "4.1": {
          "history": 7,
          "interest": 3
        },
        "4.2": {
          "history": 5,
          "interest": 2
        },
        "4.3": {
          "history": 6,
          "interest": 3
        },
        "4.4": {
          "history": 6,
          "interest": 4
        },
        "4.5": {
          "history": 3,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 1
        },
        "4.7": {
          "history": 4,
          "interest": 2
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Single parents"
  },
  {
    "name": "Emma Lewis",
    "age": 32,
    "gender": "Female",
    "status": "SAHP",
    "occupation": {
      "occupational_group": "Community and Social Service",
      "occupation": "Family Caregiver"
    },
    "industry": {
      "industry_group": "Social Assistance",
      "industry": "Family Care Services"
    },
    "skill": {
      "skill_group": "Caregiving",
      "skill": "Family Care Management"
    },
    "cause": {
      "cause_group": "Family Support",
      "cause": "Caregiver Support Programs"
    },
    "population": {
      "population_group": "Families",
      "population": "SAHP Parents"
    },
    "community": "My Neighborhood",
    "sentiments": {
      "average": 4.1,
      "rating": {
        "2.1": 4,
        "2.2": 4.5,
        "2.3": 4,
        "2.4": 4.5,
        "2.5": 4
      }
    },
    "practices": {
      "average": 4,
      "rating": {
        "3.1": 4,
        "3.2": 4,
        "3.3": 4,
        "3.4": 4
      }
    },
    "church_engagements": {
      "average_history": 3.1,
      "average_interest": 2.9,
      "rating": {
        "4.1": {
          "history": 5,
          "interest": 4
        },
        "4.2": {
          "history": 3,
          "interest": 3
        },
        "4.3": {
          "history": 4,
          "interest": 3
        },
        "4.4": {
          "history": 5,
          "interest": 4
        },
        "4.5": {
          "history": 1,
          "interest": 2
        },
        "4.6": {
          "history": 2,
          "interest": 2
        },
        "4.7": {
          "history": 2,
          "interest": 2
        }
      }
    },
    "work_location": "Workspace",
    "relationship_status": "Families"
  }
]